/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");
var startsWith = require("starts-with");
var prop = require("prop");
var par = require("par");
var xtend = require("xtend");
var window = require("global");

var hasCordovaMQTT = par(prop("cordova.plugins.CordovaMqTTPlugin"), window);

var eventMap = {
	"message": handle_message,
	"call": handle_call,
	"end": handle_end,
	"warning": handle_warning
};

module.exports = Model({
	name: "backgroundnotifications",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_localization: null,
	_people: null,
	_online: null,
	_queue: null,

	enqueue: enqueue,
	flushQueue: flushQueue,
	imageFor: imageFor,
});

function init() {
	this._localization = {};
	this._people = {};
	this._online = true;
	this._queue = [];
}

function uninit() {
	this._localization = null;
	this._people = null;
	this._queue = null;
}

function listeners() {
	var events = {
		"localization:updated": handle_localization_update,
		"backgroundsocket:line": handle_line,
		"people:updated": handle_people_updated,
		"online:updated": handle_online_updated,
		"screenfocus:updated": handle_focus_updated
	};

	if (hasCordovaMQTT())
		events = xtend(events, {
			"mqtt:$/message": handle_message,
			"mqtt:$/banner/new": handle_warning
		});

	return events;
}

function handle_line(line) {
	// Don't pop up notifications if already in the foreground
	var hasntMatched = true;
	for (var key in eventMap) {
		var data = matchData(line, key);
		if (!data) continue;
		eventMap[key].call(this, data);
		hasntMatched = false;
	}
	if (hasntMatched) console.warn("BGSocket: unable to process: " + line);
}

function handle_message(data) {
	if (this._focus) return;
	var from = data.from;
	var content = data.content;

	var fromData = this._people[from];

	if (!fromData) {
		this.enqueue("message", data);
		this.emit("people:trigger:add", {
			who: [from]
		});
		return;
	}

	var image = this.imageFor(fromData);

	this.emit("notifications:trigger:show", {
		title: format_name(fromData),
		body: content,
		image: image
	});
}

function handle_call(data) {
	if (this._focus) return;
	var from = data.from;
	var fromData = this._people[from];
	var room = data.room;
	if (!fromData) {
		this.enqueue("call", data);
		this.emit("people:trigger:add", {
			who: [from]
		});
		return;
	}

	var image = this.imageFor(fromData);

	this.emit("notifications:trigger:show", {
		title: format_name(fromData),
		body: "Incoming call",
		tag: room,
		image: image
	});
	// Pretend a call came in
	this.emit("mqtt:$/call", data);
}

function handle_end() {
	if (this._focus) return;
	if (this._online) return;
	// Pretend we denied it
	this.emit("buzz:trigger:idle", {
		reason: "socket"
	});
}

function handle_warning(data) {
	if (this._focus) return;
	var type = data.type;
	var parts = type.split(":");
	var primary = parts[0];
	var secondary = parts[1];
	var fromId = data.from;
	var toId = data.to;
	var tag = ["banner:", fromId, primary, secondary];
	var local = this._localization;
	var people = this._people;
	var toData = null,
		to = "";

	var fromData = people[fromId];
	if (toId)
		toData = people[fromId];

	if (!fromData || (toId && !toData)) {
		this.enqueue("warning", data);
		this.emit("people:trigger:add", {
			who: [fromId, toId]
		});
		return;
	}

	var from = format_name(fromData);
	if (toData)
		to = format_name(toData);

	var message = "";
	var title = from;
	var image = this.imageFor(fromData);

	if (type === "urgency:call") {
		message = [
			local.ae_banner_urgency_from,
			from,
			local.ae_banner_urgency_calling,
			to
		].join(" ");
	} else if (type === "urgency:cancelled") {
		message = [
			local.ae_banner_urgency_from,
			from
		].join(" ");
	} else if (type === "urgency:accepted") {
		message = [
			local.ae_banner_urgency_from,
			from,
			local.ae_banner_urgency_accepted,
			to
		].join(" ");
	} else if (type === "warning:inactive") {
		message = [
			from,
			local.ae_banner_warning_inactivity,
			data.min_time,
			"-",
			data.max_time,
			local.ae_banner_warning_inactive_minutes
		].join(" ");
	} else if (type === "warning:device:battery") {
		message = [
			from,
			local.ae_banner_battery_part1,
			data.battery + "%",
			local.ae_banner_battery_part2
		].join(" ");
	} else if (type === "warning:device:connected") {
		message = [
			local.ae_banner_disconnected_part1,
			from,
			local.ae_banner_disconnected_part2
		].join(" ");
	} else if (type === "warning:device:disconnected") {
		message = [
			local.ae_banner_braceletreconnect1,
			from,
			local.ae_banner_braceletreconnect2
		].join(" ");
	}

	if (!message) return;
	this.emit("notifications:trigger:show", {
		title: title,
		body: message,
		tag: tag,
		image: image
	});
}

function handle_people_updated(people) {
	this._people = people;
	this.flushQueue();
}

function format_name(person) {
	return person.fname + " " + person.lname;
}

function matchData(line, type) {
	if (!startsWith(line, type)) return false;
	if (line.length === type.length) return true;
	return JSON.parse(line.substring(type.length));
}

function handle_localization_update(localization) {
	this._localization = localization.localization;
}

function handle_online_updated(online) {
	this._online = online;
}

function handle_focus_updated(focus) {
	this._focus = focus;
}

function enqueue(type, data) {
	this._queue.push({
		type: type,
		data: data
	});
}

function flushQueue() {
	while (this._queue.length) {
		var item = this._queue.pop();
		var type = item.type;
		var data = item.data;
		if (type === "call")
			handle_call.call(this, data);
		else if (type === "message")
			handle_message.call(this, data);
		else if (type === "warning")
			handle_warning.call(this, data);
	}
}

function imageFor(data) {
	var image = data.image;
	if (!image) return "";
	return this.config.image_cdn + image;
}
